import { MarkupState, SymbolType, SystemType } from '@shared/types/tsk';

export interface ComplianceCheck {
    label: string;
    pass: boolean;
}

export interface ValidationResult {
    valid: boolean;
    checks: ComplianceCheck[];
}

/**
 * Generates a list of review prompts for the current sketch.
 * @param markup The current state of the sketch.
 * @returns A ValidationResult object containing review status and structured prompts.
 */
export const getPlanReviewChecks = (markup: MarkupState): ValidationResult => {
    const checks: ComplianceCheck[] = [
        {
            label: 'Overflow Relief Gully (ORG) included',
            pass: markup.symbols.some(s => s.type === SymbolType.ORG),
        },
        {
            label: 'Ventilation points established',
            pass: markup.lines.some(l => l.system === SystemType.VENT),
        },
        {
            label: 'System connections verified',
            pass: markup.lines.length > 0, // Soft check: at least one pipe exists
        },
    ];

    return {
        valid: checks.every(c => c.pass),
        checks,
    };
};

export const validateScheme = getPlanReviewChecks;
